var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading > 0)?_c('div',[_c('vue-progress-bar'),_c('div',{staticClass:"bg"})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }